import { createContext, useContext, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateAuth } from 'Redux/Features/auth';

const AuthContext = createContext({
  isLoggedIn: false,
  login: () => {},
  logout: () => {},
});

export const AuthProvider = (props) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  const [isLoggedIn, setIsLoggedIn] = useState(!!(user && user.id));

  const login = (data) => {
    dispatch(updateAuth(data));
    setIsLoggedIn(true);
  };

  const logout = () => {
    setIsLoggedIn(false);
    dispatch(updateAuth({}));
  };

  return <AuthContext.Provider value={{ isLoggedIn, login, logout }} {...props} />;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
